import { useNavigate } from 'react-router-dom'
import './style.css'

export function Card({ title, icon, route, image }) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (route.startsWith('http://') || route.startsWith('https://')) {
      window.open(route, '_blank', 'noopener,noreferrer')
    } else {
      navigate(route)
    }
  }

  const hasContent = title
  return (
    <div className="card" onClick={handleClick}>
      {image && (
        <div className="card-image">
          <img src={image} alt={title || 'Card image'} />
        </div>
      )}
      {icon && !image && <div className="card-icon">{icon}</div>}
      {hasContent && (
        <div className="card-content">{title && <h3 className="card-title">{title}</h3>}</div>
      )}
    </div>
  )
}
